module.exports = __webpack_public_path__ + "img/part_tab3_box1.fa5d838b.jpg";